export enum RequestTypeEnum {
  PLATFORM_REQUEST = 'Richiesta di assistenza su Piattaforma',
  TECH_SUPPORT_REQUEST = 'Richieste di assistenza tecnico - specialistico (a pagamento)',
}
